import React, { PureComponent, Fragment } from 'react'
import { formatPrice } from 'helpers'
import moment from 'moment'
import cx from 'classnames'

import { Grid, Cell } from 'components/layout/grid'
import Button from 'components/ui/Button/Button'
import Box from 'components/layout/Box/Box'


class PaymentReport extends PureComponent {

  state = {
    node: null,
  }

  componentDidMount() {
    const encodedUri  = this.getEncodeUri()
    const link        = document.createElement('a')

    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${this.getTitle()}.csv`)

    document.body.appendChild(link)

    this.setState({ node: link })
  }

  componentWillUnmount() {
    const { node } = this.state

    document.body.removeChild(node)
  }

  getTitle = () => {
    const { from, to, paymentType } = this.props

    const date = `с ${moment(from, 'DDMMYYYY').format('DD.MM.YYYY')} по ${moment(to, 'DDMMYYYY').format('DD.MM.YYYY')}`

    return paymentType === 'success' ? `Отчет: Продажи ${date}` : `Отчет: Платежи ${date}`
  }

  getEncodeUri = () => {
    const { statistic, total: paymentTotal, learnTotal, subscrTotal, schedTotal } = this.props

    let encodeData = 'data:text/csv;charset=utf-8,\uFEFF'

    const rows = []

    rows.push([ this.getTitle() ])
    rows.push([
      'Номер заказа', 'Проверочный код', 'Сумма (руб.)', 'Тип заказа', 'Статус платежа', 'Дата платежа', 'Дата возврата',
      'Дата частичного возврата', 'Сумма частичного возврата', 'Тариф',
    ])

    const subscriptions = (statistic.subscriptions ? statistic.subscriptions : statistic).reverse()

    subscriptions.forEach(({ active, id, subscriber, transaction, canceledAt, ts, voucher, quota, trainer, tariffCategory, tariff }, index) => {
      const { acquireReqStatus, amount, status, partRefundAt, partRefundAmount } = transaction
      const { birth, gender, label } = subscriber
      const { firstName, lastName, middleName } = trainer || {}

      const prevType    = index && ((subscriptions[index - 1].tariffCategory || {}).type || {}).type
      const tariffType  = tariffCategory.type && tariffCategory.type.type

      const isSchedule  = tariffType === 'SCHEDULE'
      const wasSchedule = index && prevType === 'SCHEDULE'

      const isTicket    = tariffType === 'SUBSCRIPTION'
      const wasTicket   = index && prevType === 'SUBSCRIPTION'

      const isLearn     = tariffType === 'LEARN'
      const wasLearn    = index && prevType === 'LEARN'

      const { name: tariffName } = (isTicket ? tariff : tariffCategory) || {}

        let type = ''

      if (isSchedule) {
        if (!wasSchedule) {
          rows.push([ 'Разовые посещения' ])
        }

        type = 'Разовое посещение'
      }
      if (isTicket) {
        if (!wasTicket) {
          rows.push([ 'Абонементы' ])
        }

        type = `Абонемент (${quota})`
      }
      if (isLearn) {
        if (!wasLearn) {
          rows.push([ 'Обучение' ])
        }

        type = 'Обучение'
      }

      rows.push([
        id, voucher, Number(amount) / 100, type, status,
        `${moment(ts).format('DD.MM.YYYY')} ${moment(ts).format('HH:mm')}`,
        Boolean(canceledAt) ? `${moment(canceledAt).format('DD.MM.YYYY')} ${moment(canceledAt).format('HH:mm')}` : '',
        Boolean(partRefundAt) ? `${moment(partRefundAt).format('DD.MM.YYYY')} ${moment(partRefundAt).format('HH:mm')}` : '',
        partRefundAmount ? formatPrice(partRefundAmount, true, true) : 0,
        (tariffName || '').replace(/"/g, '\'').replace(/;/g, ''),
      ])
    })

    if (paymentTotal) {
      rows.push([ `Итого: ${formatPrice(paymentTotal, true, true)}` ])
    }
    if (learnTotal) {
      rows.push([ `Итого (обучение): ${formatPrice(learnTotal, true, true)}` ])
    }
    if (subscrTotal) {
      rows.push([ `Итого (абонементы): ${formatPrice(subscrTotal, true, true)}` ])
    }
    if (schedTotal) {
      rows.push([ `Итого (разовые посещения): ${formatPrice(schedTotal, true, true)}` ])
    }

    return `${encodeData}${
      rows.map((items) => (
        items.map((item) => String(item || '')).join(';')
      ))
        .join('\n')
      }`
  }

  handleButtonClick = () => {
    const { node } = this.state
    const { onClose } = this.props

    node.click()
    onClose()
  }

  render() {
    const {
      className, titleClassName, buttonClassName, darkClassName, darkestClassName,
      statistic, total: paymentTotal, learnTotal, subscrTotal, schedTotal, isEmpty,
    } = this.props

    const subscriptions = (statistic.subscriptions ? statistic.subscriptions : statistic).reverse()

    return (
      <div className={className}>
        <Box pb="md">
          <div className={titleClassName}>{this.getTitle()}</div>
        </Box>
        {
          isEmpty ? (
            <div>Нет статистики по выбранным условиям</div>
          ) : (
            <Fragment>
              {
                subscriptions.map((data, index) => {
                  const { active, id, subscriber, transaction, ts, voucher, quota, trainer, canceledAt, tariffCategory, tariff, usages } = data
                  const { acquireReqStatus, amount, status, partRefundAt, partRefundAmount  } = transaction
                  const { birth, gender, label } = subscriber
                  const { firstName, lastName, middleName } = trainer || {}

                  const prevType    = index && ((subscriptions[index - 1].tariffCategory || {}).type || {}).type
                  const tariffType  = tariffCategory.type && tariffCategory.type.type

                  const isSchedule  = tariffType === 'SCHEDULE'
                  const wasSchedule = index && prevType === 'SCHEDULE'

                  const isTicket    = tariffType === 'SUBSCRIPTION'
                  const wasTicket   = index && prevType === 'SUBSCRIPTION'

                  const isLearn     = tariffType === 'LEARN'
                  const wasLearn    = index && prevType === 'LEARN'

                  const { name: tariffName } = (isTicket ? tariff : tariffCategory) || {}

                  return (
                    <Fragment key={index}>
                      {
                        Boolean(!index) && (
                          <Grid className={darkClassName} columns={status ? 10 : 9} gutter="md">
                            <Cell size={1}>
                              Номер заказа
                            </Cell>
                            <Cell size={1}>
                              Проверочный код
                            </Cell>
                            <Cell size={1}>
                              Сумма
                            </Cell>
                            <Cell size={1}>
                              Тип заказа
                            </Cell>
                            {
                              Boolean(status) && (
                                <Cell size={1}>
                                  Статус платежа
                                </Cell>
                              )
                            }
                            <Cell size={1}>
                              Дата платежа
                            </Cell>
                            <Cell size={1}>
                              Дата возврата
                            </Cell>
                            <Cell size={1}>
                              Дата частичного возврата
                            </Cell>
                            <Cell size={1}>
                              Сумма частичного возврата
                            </Cell>
                            <Cell size={1}>
                              Тариф
                            </Cell>
                          </Grid>
                        )
                      }
                      {
                        Boolean(isSchedule && !wasSchedule) && (
                          <Grid className={darkestClassName} columns={1} gutter="md">
                            <Cell size={1}>
                              Разовые посещения
                            </Cell>
                          </Grid>
                        )
                      }
                      {
                        Boolean(isTicket && !wasTicket) && (
                          <Grid className={darkestClassName} columns={1} gutter="md">
                            <Cell size={1}>
                              Абонементы
                            </Cell>
                          </Grid>
                        )
                      }
                      {
                        Boolean(isLearn && !wasLearn) && (
                          <Grid className={darkestClassName} columns={1} gutter="md">
                            <Cell size={1}>
                              Обучение
                            </Cell>
                          </Grid>
                        )
                      }
                      <Grid className={cx({ [darkClassName]: index % 2 !== 0 })} columns={status ? 10 : 9} gutter="md">
                        <Cell size={1}>
                          {id}
                        </Cell>
                        <Cell size={1}>
                          {voucher}
                        </Cell>
                        <Cell size={1}>
                          {formatPrice(amount, true, true)}
                        </Cell>
                        <Cell size={1}>
                          {
                            isSchedule && (
                              <div>Разовое посещение</div>
                            )
                          }
                          {
                            isTicket && (
                              <div>Абонемент ({quota})</div>
                            )
                          }
                          {
                            isLearn && (
                              <div>Обучение</div>
                            )
                          }
                        </Cell>
                        {
                          Boolean(status) && (
                            <Cell size={1}>
                              {status}
                            </Cell>
                          )
                        }
                        <Cell size={1}>
                          {moment(ts).format('DD.MM.YYYY')} {moment(ts).format('HH:mm')}
                        </Cell>
                        {
                          Boolean(canceledAt) ? (
                            <Cell size={1}>
                              {moment(canceledAt).format('DD.MM.YYYY')} {moment(canceledAt).format('HH:mm')}
                            </Cell>
                          ) : (
                            <Cell size={1} />
                          )
                        }
                        <Cell size={1}>
                          {
                            Boolean(partRefundAt)
                              ? `${moment(partRefundAt).format('DD.MM.YYYY')} ${moment(partRefundAt).format('HH:mm')}`
                              : ''
                          }
                        </Cell>
                        <Cell size={1}>
                          {
                            Boolean(partRefundAmount)
                              ? formatPrice(partRefundAmount, true, true)
                              : '0'
                          }
                        </Cell>
                        <Cell size={1}>
                          <span dangerouslySetInnerHTML={{ __html: tariffName }} />
                        </Cell>
                      </Grid>
                    </Fragment>
                  )
                })
              }
              <Grid columns={1} gutter="md">
                {
                  Boolean(paymentTotal) && (
                    <Cell size={1}><b>Итого: {formatPrice(paymentTotal, true, true)}</b></Cell>
                  )
                }
                {
                  Boolean(learnTotal) && (
                    <Cell size={1}><b>Итого (обучение): {formatPrice(learnTotal, true, true)}</b></Cell>
                  )
                }
                {
                  Boolean(subscrTotal) && (
                    <Cell size={1}><b>Итого (абонементы): {formatPrice(subscrTotal, true, true)}</b></Cell>
                  )
                }
                {
                  Boolean(schedTotal) && (
                    <Cell size={1}><b>Итого (разовые посещения): {formatPrice(schedTotal, true, true)}</b></Cell>
                  )
                }
              </Grid>
              <Box pt="md">
                <Button
                  className={buttonClassName}
                  title="Сохранить в файл"
                  green
                  onClick={this.handleButtonClick}
                />
              </Box>
            </Fragment>
          )
        }
      </div>
    )
  }
}


export default PaymentReport
